export const convertTimestampToDate = (timestamp) => {
  if (timestamp) {
    var date = new Date(+timestamp);
    return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
  }
  return '';
};

export const convertTimestampToTime = (timestamp) => {
  if (timestamp) {
    var date = new Date(+timestamp);
    return `${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}-${date.getMilliseconds()}`;
  }
  return '';
};

export const formatSmartTimestamp = (timestamp) => {
  if (!timestamp) return '';

  const date = new Date(parseInt(timestamp));
  const today = new Date();

  // Vérifier si c'est le même jour
  const isSameDay =
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear();

  if (isSameDay) {
    // Afficher juste l'heure (HH:MM)
    return date.toLocaleTimeString('fr-FR', {
      hour: '2-digit',
      minute: '2-digit',
    });
  }
  // Vérifier si c'est la même année
  const isSameYear = date.getFullYear() === today.getFullYear();

  if (isSameYear) {
    // Même année : afficher juste jour/mois (28/12)
    return date.toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
    });
  }
  // Année différente : afficher avec année courte (28/12/25)
  return date.toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
  });
};
